import { Button, TextField } from "@mui/material";
import styles from "./addrole.module.css";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import axios from 'axios';
import { toast } from 'react-smart-toaster';
import { AddLogCallAPI } from "../../../components/AddLogs";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";

const schema = yup.object().shape({
    name: yup.string().required('This field is Required').max(20, 'Name cannot be more than 20 characters'),
    description: yup.string().required('This field is Required').max(200, 'Description cannot be more than 200 characters'),
});

const AddRole = ({ setAddModalOpen, setLoading, setSnackbarOpen, setSnackbarMsg, setAllData, roleData }) => {
    const { getAccessTokenSilently } = useAuth0();

    const { handleSubmit, control, errors, setValue } = useForm({
        resolver: yupResolver(schema), mode: 'onChange',
        defaultValues: {
            name: '',
            description: ''
        }
    });

    useEffect(() => {
        if (roleData) {
            setValue('name', roleData?.name);
            setValue('description', roleData?.description);
        }
    }, [roleData, setValue]);

    const onSubmit = async (data) => {
        setLoading(true);
        setAddModalOpen(false);

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        return axios.post(process.env.REACT_APP_USER_API_URL + 'v1/roles', data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }).then(response => {
            setLoading(false);

            setSnackbarOpen(true);
            setSnackbarMsg(response.data.message);

            setAllData(prev => {
                return [response.data.data].concat(prev);
            });

            let logData = {
                'title': 'A new role has been added.',
                'description': [
                    'Name: ' + response.data.data?.name
                ]
            }
            AddLogCallAPI(logData, token);
        }).catch(error => {
            if (typeof error.response !== 'undefined')
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    const onUpdate = async (data) => {
        setLoading(true);
        setAddModalOpen(false);

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        return axios.post(process.env.REACT_APP_USER_API_URL + 'v1/roles/' + roleData?.id, data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }).then(response => {
            setLoading(false);

            setSnackbarOpen(true);
            setSnackbarMsg(response.data.message);

            setAllData(prev => {
                return prev?.map(i => {
                    if (i?.id === roleData?.id)
                        return { ...i, name: response.data.data?.name, description: response.data.data?.description };
                    return i;
                });
            });

            let logData = {
                'title': 'A role has been updated.',
                'description': [
                    'Name: ' + response.data.data?.name
                ]
            }
            AddLogCallAPI(logData, token);
        }).catch(error => {
            if (typeof error.response !== 'undefined')
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    return (<div>
        <form onSubmit={handleSubmit(roleData ? onUpdate : onSubmit)}>
            <div className={`${styles.ReqAddRow}`}>
                <div className={`${styles.ReqAddFormSec}`}>
                    <div className={`${styles.FormSecRow}`}>
                        <div className={`${styles.FormGroupFull} FormGroup`}>
                            <Controller
                                name={`name`}
                                control={control}
                                render={(field) => (<TextField  {...field} id="outlined-basic" label="Name*" variant="outlined" />)}
                            />
                            {errors.name && (<p className={`${styles.ErrorM}`}>{errors?.name?.message}</p>)}
                        </div>
                        <div className={`${styles.FormGroupFull} FormGroup`}>
                            <Controller
                                name={`description`}
                                control={control}
                                render={(field) => (<TextField {...field} id="outlined-basic" label="Description*" variant="outlined" multiline rows={8} />)}
                            />
                            {errors.description && (<p className={`${styles.ErrorM}`}>{errors?.description?.message}</p>)}
                        </div>
                    </div>
                </div>
            </div>
            <div className={`${styles.ButtonActionTwo}`}>
                <Button onClick={(e) => setAddModalOpen(false)} className="CancelPopupBU">Cancel</Button>
                <Button className="SubmitPopupBU" type="submit">{roleData ? 'Update' : 'Add'}</Button>
            </div>
        </form>
    </div>)
}

export default AddRole;
